export const rotate_cw = () => (
  <path
    d="M23 4v6m0 0h-6m6 0l-4.63-4.36A9 9 0 1020.49 15"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
